"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPatchDigestPreferencesResponseDto = instanceOfPatchDigestPreferencesResponseDto;
exports.PatchDigestPreferencesResponseDtoFromJSON = PatchDigestPreferencesResponseDtoFromJSON;
exports.PatchDigestPreferencesResponseDtoFromJSONTyped = PatchDigestPreferencesResponseDtoFromJSONTyped;
exports.PatchDigestPreferencesResponseDtoToJSON = PatchDigestPreferencesResponseDtoToJSON;
exports.PatchDigestPreferencesResponseDtoToJSONTyped = PatchDigestPreferencesResponseDtoToJSONTyped;
/**
 * Check if a given object implements the PatchDigestPreferencesResponseDto interface.
 */
function instanceOfPatchDigestPreferencesResponseDto(value) {
    if (!('savedAt' in value) || value['savedAt'] === undefined)
        return false;
    if (!('sportCodes' in value) || value['sportCodes'] === undefined)
        return false;
    return true;
}
function PatchDigestPreferencesResponseDtoFromJSON(json) {
    return PatchDigestPreferencesResponseDtoFromJSONTyped(json, false);
}
function PatchDigestPreferencesResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'savedAt': json['savedAt'],
        'sportCodes': json['sportCodes'],
    };
}
function PatchDigestPreferencesResponseDtoToJSON(json) {
    return PatchDigestPreferencesResponseDtoToJSONTyped(json, false);
}
function PatchDigestPreferencesResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'savedAt': value['savedAt'],
        'sportCodes': value['sportCodes'],
    };
}
